export default "__VITE_ASSET__QFFkCqcO__"